module.exports = __webpack_public_path__ + "static/media/ali-review.b5f43379.png";